import { NavLink } from 'react-router-dom'
import { useAuth } from '../lib/auth'

// Port of app/js/sidebar.js — same grouped sections, same icons, same tenant
// overrides, same hide rules. Single source of truth as JSX so we don't drift.

// SVG icons mirror the ICONS dict in app/js/sidebar.js. Inline so they pick up
// currentColor for theme switching.
const ICONS = {
  creatives: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
    </svg>
  ),
  agents: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 8V4H8"/><rect x="8" y="8" width="8" height="8" rx="1"/><path d="M12 16v4h4"/><path d="M8 12H4"/><path d="M20 12h-4"/>
    </svg>
  ),
  pnl: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  ),
  // Cone of uncertainty: a known point, then two diverging bounds.
  horizon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 12h5"/><path d="M7 12l14-6"/><path d="M7 12l14 6" strokeDasharray="3 3"/><circle cx="7" cy="12" r="1.6"/>
    </svg>
  ),
  book: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z"/><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
    </svg>
  ),
  attribution: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 21H4.6c-.6 0-.9 0-1.1-.1a1 1 0 0 1-.4-.4c-.1-.2-.1-.5-.1-1.1V3"/><path d="m7 14 4-4 4 4 6-6"/>
    </svg>
  ),
  mmm: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/>
    </svg>
  ),
  incrementality: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>
    </svg>
  ),
  experiments: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 2h6l3 7H6L9 2z"/><path d="M6 9v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9"/><path d="M10 13h4"/><path d="M12 11v4"/>
    </svg>
  ),
  playbook: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
    </svg>
  ),
  insights: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z"/><path d="M20 10l.7 2.1L23 13l-2.3.9L20 16l-.7-2.1L17 13l2.3-.9L20 10z"/><path d="M4 16l.7 2.1L7 19l-2.3.9L4 22l-.7-2.1L1 19l2.3-.9L4 16z"/>
    </svg>
  ),
  settings: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  // Creative · Performance — vertical bar chart (different stroke from `mmm`
  // so the icon reads as performance-focused rather than modelling).
  chart: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  ),
  // Creative · Intelligence — tag icon. Represents the underlying function
  // (classifying / tagging creative features). No brain, no bulb, no sparkle.
  brain: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41 13.41 20.59a2 2 0 0 1-2.82 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
      <line x1="7" y1="7" x2="7.01" y2="7"/>
    </svg>
  ),
} as const

type IconKey = keyof typeof ICONS

interface NavItem {
  href: string
  label: string
  icon?: IconKey
  tenantHide?: string[]
  tenantOnly?: string[]
  tenantOverride?: Record<string, string>
  superAdminOnly?: boolean
  indented?: boolean
}
interface NavSection {
  header: string
  items: NavItem[]
}

// Clean URLs for navigation (no .html). App.tsx keeps the .html routes
// registered as aliases so old bookmarks and inter-page deep links still resolve.
const SECTIONS: NavSection[] = [
  // No "Live" section. The live surface is the home page (Mission Control).
  { header: 'Creative', items: [
    // All Creative pages require the paid-ads tables (creative_ads_full,
    // creative_daily_metrics) which only SP / 4P populate. ConsumerAffairs
    // runs on form submissions + cost-per-match, not paid creative — hide
    // entire section for them rather than serving 500s.
    //
    // Three-Audience IA (2026-05-24): three opinionated surfaces sharing
    // the same data layer but tuned for distinct jobs/personas:
    //   • Performance  = Media Buyer's daily triage     (Creative.tsx)
    //   • Intelligence = Strategist / creative narrative (CreativeIncrementality.tsx)
    //   • Studio       = Analyst's deep dive            (CreativeStudioV2.tsx)
    // Replaced the brief Hub experiment that tried to merge Performance +
    // Intelligence — losing audience-fit was worse than the IA cleanliness
    // gain. See docs/CREATIVE_UNIFIED_PLAN.md for the original Hub plan;
    // it's superseded by the three-audience model.
    // CA enabled 2026-05-28: BQ views + creative_analysis_v2 + motion_tags populated.
    { href: '/coverage',              label: 'Coverage',     icon: 'chart' },
    { href: '/levers',                label: 'Levers',       icon: 'brain' },
    { href: '/creative',              label: 'Performance',  icon: 'chart' },
    { href: '/creative-intelligence', label: 'Intelligence', icon: 'brain' },
    // Strategy — persona×awareness + LP-coverage heatmaps. Live for CA and 4P
    // (4P wired in via PR #22: groups by analyzer vertical — solar/food/water).
    // Still hidden for SP, which has no v3 strategy data yet.
    // SP unhidden 2026-07-06 (Brent): SP now has v3 analysis + classify + gap data;
    // page degrades to not_ready until its clusterer/views land post-#63.
    { href: '/creative-strategy',     label: 'Strategy',     icon: 'agents' },
    { href: '/studio-v2',             label: 'Studio',       icon: 'creatives' },
    { href: '/meta-sandbox',          label: 'Creative Sandbox', icon: 'agents', tenantHide: ['consumeraffairs', '4patriots'] },
  ]},
  { header: 'Measurement', items: [
    { href: '/financials',  label: 'P&L', icon: 'pnl',
      tenantOverride: { consumeraffairs: '/financials-ca', '4patriots': '/pnl-4patriots' } },
    { href: '/attribution', label: 'Attribution', icon: 'attribution',
      tenantOverride: { consumeraffairs: '/attribution-ca' } },
    { href: '/mmm',         label: 'MMM', icon: 'mmm',
      tenantOverride: { consumeraffairs: '/mmm-ca' } },
    // Incrementality (/ghost) is experiment-iROAS based. Hidden for SP — SP
    // experiments are invalid, so the page would show false incrementality.
    // CA overrides to its own page; 4P keeps it (valid experiments).
    { href: '/ghost',       label: 'Incrementality', icon: 'incrementality',
      tenantHide: ['supportpets'],
      tenantOverride: { consumeraffairs: '/ghost-ca' } },
  ]},
  { header: 'Workflow', items: [
    { href: '/experiments', label: 'Experiments', icon: 'experiments' },
    { href: '/playbook',    label: 'Playbook', icon: 'playbook',
      tenantOverride: {
        '4patriots': '/playbook-4patriots',
        consumeraffairs: '/playbook-ca',
        warmies: '/playbook-warmies',
      } },
    // The ratified CA plan sheet, synced weekly (docs/PLAN_SYNC.md). CA only:
    // no other tenant has a plan sheet. A tab, not the landing view.
    { href: '/plan',        label: 'Plan', icon: 'playbook', tenantOnly: ['consumeraffairs'] },
  ]},
]

const BOTTOM_ITEMS: NavItem[] = [
  // Insights = the agentic chat rebuild (/insights). Classic /reports stays
  // routable (linked from the new page header) until the chat reaches parity.
  { href: '/insights', label: 'Figgy', icon: 'insights' },
  { href: '/settings', label: 'Settings', icon: 'settings' },
]

// Shell tenants (newly onboarded, no analytics pipeline yet) get a stripped
// nav: only Mission Control (the parent link) + Experiments + Settings. Every
// other page depends on analytics tables they don't have yet, so hide them
// rather than serve empty/500 surfaces. Keyed by the href each item resolves to.
// /ghost joined the list 2026-08-18: Warmies now has a real incrementality
// surface. The Meta holdout (exp_aa52d6c5e0af) is registered in
// experiment_baselines and warmies-drift-scheduler refreshes
// experiment_drift_daily daily, so the page renders measured iROAS rather than
// the empty/500 the allowlist was protecting against.
// /mmm joined 2026-09-02: channel_spend_daily carries Warmies' facebook/
// google/tiktok split and mmm_regression_results has a real fit (facebook
// anchored on the Meta holdout; Google/TikTok pooled -- see
// mmm_regression.py load_data comments). /api/mmm-dashboard sources Warmies'
// channels from that table directly (experiment_drift_daily has no running
// state-space pipeline for this tenant yet), then falls through to the
// existing heuristic Hill-curve estimate for saturation curves + budget
// optimization, same as any other tenant without calibrated/PyMC coverage.
// /mmm removed again 2026-10-11: the ridge fit above covers only ~89 days (no Q4) and
// no Meridian fit passed the gate (docs/WARMIES_MMM_MERIDIAN_BAKEOFF_2026-10.md);
// /api/mmm-dashboard now returns not_available for warmies.
// /creative (Performance) joined 2026-09-10: creative_daily_metrics has a
// real Warmies ETL (_refresh_daily_metrics_warmies) with real spend/CTR/CPM/
// format AND revenue/roas (warmies_conversions_pull.py, Meta's own reported
// per-ad conversions).
// /creative-intelligence joined 2026-09-10, but is NOT yet backed by real
// data: it reads the v_creative_intelligence_x_perf VIEW (never deployed for
// warmies_analytics) plus creative_analysis_v2 (all rows status='exception'
// -- the meta_asset_scraper scrape step is failing on graph.facebook.com
// connection errors, so v2 never got an image to analyze). Kept visible per
// explicit ask; it degrades to a "view not present" message rather than
// erroring. /studio-v2 and /creative-strategy were tried and removed again
// (2026-09-10) -- Studio's ~38-ad sample and Strategy's not_ready empty
// state weren't what was wanted; hooks/angles belong under Intelligence
// instead once its two blockers above are fixed.
// /meta-sandbox (Creative Sandbox) deliberately NOT added -- SPSandbox.tsx
// and its backing routes are hardcoded SupportPets-only ("sandbox is
// SupportPets-only" in app/api.py), not just missing data for this tenant.
const MINIMAL_NAV_TENANTS = new Set<string>(['warmies'])
const MINIMAL_NAV_ALLOW = new Set<string>(['/attribution', '/experiments', '/insights', '/reports', '/settings', '/playbook-warmies', '/ghost', '/creative', '/creative-intelligence'])

export function Sidebar() {
  const { me, activeTenant } = useAuth()
  const tenant = activeTenant || me?.tenant_id || null
  const isAdmin = !!me?.is_super_admin
  const minimal = !!tenant && MINIMAL_NAV_TENANTS.has(tenant)

  const resolve = (item: NavItem): string =>
    (tenant && item.tenantOverride?.[tenant]) || item.href

  const visible = (item: NavItem): boolean => {
    if (item.superAdminOnly && !isAdmin) return false
    if (item.tenantHide && tenant && item.tenantHide.includes(tenant)) return false
    if (item.tenantOnly && !(tenant && item.tenantOnly.includes(tenant))) return false
    // Shell tenants: allow only the explicitly whitelisted destinations.
    if (minimal && !MINIMAL_NAV_ALLOW.has(resolve(item))) return false
    return true
  }

  const renderItem = (item: NavItem, extraClass = '') => (
    <NavLink
      key={item.href}
      to={resolve(item)}
      className={({ isActive }) => `nav-child ${extraClass} ${isActive ? 'active' : ''}`.trim()}
      style={item.indented ? { paddingLeft: 36, fontSize: 12 } : undefined}
    >
      {item.icon && <span style={{ display: 'inline-flex', marginRight: 8, verticalAlign: 'middle' }}>{ICONS[item.icon]}</span>}
      {item.label}
    </NavLink>
  )

  return (
    <nav className="sidebar-nav">
      <NavLink to="/" className={({ isActive }) => 'nav-parent' + (isActive ? ' active' : '')}>
        Mission Control
      </NavLink>
      <div className="nav-children">
        {SECTIONS.map((sec) => {
          const items = sec.items.filter(visible)
          if (!items.length) return null
          return (
            <div key={sec.header}>
              <div className="nav-section-header">{sec.header}</div>
              {items.map((it) => renderItem(it))}
            </div>
          )
        })}
      </div>
      <div style={{ marginTop: 'auto' }}>
        {BOTTOM_ITEMS.filter(visible).map((item) => (
          <NavLink key={item.href} to={item.href}
                   className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
            {item.icon && <span style={{ display: 'inline-flex', marginRight: 8, verticalAlign: 'middle' }}>{ICONS[item.icon]}</span>}
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
